import _ from 'lodash'
import type moment from 'moment'

/*
  This is a generic tree for storing Employee Blocked Periods,
  Leaves and Company Holidays as a tree of dates with the following structure:
  The values that can be included in the array are:
  - '' (empty string) - for blocked periods and leaves
  - 'wrong' - for company holidays
  (It's because of css classes I think)
  {
    2020: {
      1: {
        1: [''],
        2: ['wrong', 'focus'],
        ...
      },
    2021: { ... },
  }
*/
type Tree = Record<string, Record<string, Record<string, string[]>>>

export default function insertToTree(
  memo: Tree,
  type: string
): (momentDate: moment.Moment) => void {
  return (momentDate: moment.Moment) => {
    const year = momentDate.year()
    const month = momentDate.month() + 1
    const date = momentDate.date()
    const classes = type.split(' ')
    memo[year] = memo[year] || {}
    memo[year][month] = memo[year][month] || {}
    memo[year][month][date] = memo[year][month][date] || []
    memo[year][month][date].push(...classes)
    memo[year][month][date] = _.uniq(memo[year][month][date])
  }
}
